import Logger from "./../lib/logger";
import { RepositoryFactory } from "./../repository/RepositoryFactory";
import { makeCancellable, takeLatest } from "vuex-cancellable-actions";
const RiverWarnGeojsonRepository = RepositoryFactory.get("riverWarnGeojson");
const RiverWarnJsonRepository = RepositoryFactory.get("riverWarnJson");
const MapJsonRepository = RepositoryFactory.get("mapJsonRepository");

export default {
  namespaced: true,
  state: {
    /** 河川予警報設定 */
    riverWarnConfig: {},
    /** 表示範囲の河川予警報GeoJson */
    rwGeoJson: [],
    /** 選択中河川予警報GeoJson */
    selectedRwGeoJson: null,
    /** 表示範囲の河川予警報データ */
    riverWarnsList: [],
    /** 表示範囲の河川予警報データ(概況画面)*/
    riverWarnsOvList: [],
    /** 表示範囲の河川予警報データ(拡大画面)*/
    riverWarnsFullList: [],
    /** 表示範囲の河川予警報データパラメータ */
    riverWarnsParam: {
      /** 表示時刻 */
      dispTime: null,
      /** 市町村リスト取得時刻 */
      townsAcqTime: null,
    },
    /** 表示範囲の河川予警報データパラメータ（概況画面） */
    riverWarnsOvParam: {
      /** 表示時刻 */
      dispTime: null,
      /** 市町村リスト取得時刻 */
      townsAcqTime: null,
    },
    /** 表示範囲の河川予警報データパラメータ（拡大画面） */
    riverWarnsFullParam: {
      /** 表示時刻 */
      dispTime: null,
      /** 市町村リスト取得時刻 */
      townsAcqTime: null,
    },
    /** 選択中河川予警報リクエストキー */
    selectedWarnReq: {},
    /** 選択中河川予警報タイプ */
    selectedWarnType: 0,
    /** 選択中予警報発表番号 */
    selectedAnnNo: 1,
    selectedAnnIdx: 0,
    /** 概況模式図のURL */
    overviewUrl: "/kawabou/img/rw",
    /** 概況模式図の表示レベル 全国:80 地方:81～90 */
    overviewLevel: 80,
    /** 概況模式図の選択都道府県 */
    overviewPref: 0,
    /** 概況模式図の地方毎のステータス */
    overviewState: {
      fldfr: [],
      fldctl: [],
      damsch: [],
    },
    /** 履歴動画再生状態('ready':準備状態, 'playable':再生可状態) */
    historyPlayPrepStatus: "ready",
    /** 河川予警報存在フラグ */
    rwExistenceFlg: false,
    /** 選択中河川予警報詳細・マスタ情報 */
    selectedRwDetail: {
      /** 河川予警報マスタ情報 */
      mt: {},
      /** 河川予警報詳細 */
      rw: [],
      /** 最新河川予警報詳細*/
      rwBase: [],
      /** 区間コード */
      cd: 0,
      /** 河川予警報詳細フラグ */
      rwFlg: false,
    },
  },
  mutations: {
    /**
     * 河川予警報設定を設定
     * @param {*} state
     * @param {*} riverWarnConfig 河川予警報設定
     */
    setRiverWarnConfig(state, riverWarnConfig) {
      Logger.debug(
        "[RiverWarn]mut - setRiverWarnConfig(state,riverWarnConfig)"
      );
      Logger.dir(riverWarnConfig);
      state.riverWarnConfig = riverWarnConfig;
    },
    /**
     * API実行時のパラメータを保持
     * @param {*} state
     * @param appTime 対象日時
     */
    setRiverWarnsParamDispTime(state, appTime) {
      Logger.debug(
        "[RiverWarn]mut - setRiverWarnsParamDispTime(state," + appTime + ")"
      );
      state.riverWarnsOvParam.dispTime = appTime;
      state.riverWarnsFullParam.dispTime = appTime;
    },
    /**
     * API実行時のパラメータを保持
     * @param {*} state
     * @param appTime 対象日時
     * @param townsAcqTime 市町村リスト取得日時
     */
    setRiverWarnsParam(state, { dispTime, townsAcqTime }) {
      Logger.debug(
        "[RiverWarn]mut - setRiverWarnsParam(state, {" +
          dispTime +
          "," +
          townsAcqTime +
          "})"
      );
      state.riverWarnsParam.dispTime = dispTime;
      state.riverWarnsParam.townsAcqTime = townsAcqTime;
    },
    /**
     * API実行時のパラメータを保持(概況画面)
     * @param {*} state
     * @param appTime 対象日時
     * @param townsAcqTime 市町村リスト取得日時
     */
    setRiverWarnsOvParam(state, { dispTime, townsAcqTime }) {
      Logger.debug(
        "[RiverWarn]mut - setRiverWarnsOvParam(state, {" +
          dispTime +
          "," +
          townsAcqTime +
          "})"
      );
      state.riverWarnsOvParam.dispTime = dispTime;
      state.riverWarnsOvParam.townsAcqTime = townsAcqTime;
    },
    /**
     * API実行時のパラメータを保持(拡大画面)
     * @param {*} state
     * @param appTime 対象日時
     * @param townsAcqTime 市町村リスト取得日時
     */
    setRiverWarnsFullParam(state, { dispTime, townsAcqTime }) {
      Logger.debug(
        "[RiverWarn]mut - setRiverWarnsFullParam(state, {" +
          dispTime +
          "," +
          townsAcqTime +
          "})"
      );
      state.riverWarnsFullParam.dispTime = dispTime;
      state.riverWarnsFullParam.townsAcqTime = townsAcqTime;
    },

    /**
     * 河川予警報一覧をstateに設定
     * @param {*} state
     * @param {*} rw
     */
    setRiverWarnsList(state, rw) {
      Logger.debug("[RiverWarn]mut - setRiverWarnsList(state, {})");
      Logger.dir(rw);
      state.riverWarnsList = rw;
    },
    /**
     * 河川予警報一覧をstateに設定(概況画面)
     * @param {*} state
     * @param {*} rw
     */
    setRiverWarnsOvList(state, rw) {
      Logger.debug("[RiverWarn]mut - setRiverWarnsOvList(state, {})");
      Logger.dir(rw);
      state.riverWarnsOvList = rw;
    },
    /**
     * 河川予警報一覧をstateに設定(拡大画面)
     * @param {*} state
     * @param {*} rw
     */
    setRiverWarnsFullList(state, rw) {
      Logger.debug("[RiverWarn]mut - setRiverWarnsFullList(state, {})");
      Logger.dir(rw);
      state.riverWarnsFullList = rw;
    },
    /**
     * 河川予警報詳細・マスタ情報設定
     * @param {*} state
     * @param {*} mt マスタ情報
     * @param {*} rw 予警報詳細
     * @param {*} type 予警報種別
     */
    setSelectedRwDetail(state, { mt, rw, type, rwFlg }) {
      Logger.debug(
        "[RiverWarn]mut - setSelectedRwDetail(" + mt + rw + type + rwFlg + ")"
      );
      Logger.dir(mt, rw, type, rwFlg);
      //発表号数順にソートの並び替え
      rw.sort(function(a, b) {
        if (a.annNo < b.annNo) return 1;
        if (a.annNo > b.annNo) return -1;
        return 0;
      });
      if (type == 10) {
        // 洪水予報
        for (const rwList of rw) {
          Logger.debug("[RiverWarn]mut - setSelectedRwDetail 洪水予報");
          for (const obs of rwList.stgobs) {
            var stg = 0;
            var isNoData = true;
            var tendency = 0;
            for (const pred of obs.predstg) {
              // 最初のデータを保持;
              if (stg === 0) {
                stg = pred.stg;
                Logger.debug(
                  "[RiverWarn]mut - setSelectedRwDetail 最初のデータ:" + stg
                );
                continue;
              }
              // 予測水位がない場合はスキップ
              if (pred.stg == null) {
                continue;
              }
              isNoData = false;
              if (stg <= pred.stg - state.riverWarnConfig.predstgValue) {
                // 初期値より大きい場合は、1
                tendency = 1;
                Logger.debug(
                  "[RiverWarn]mut - setSelectedRwDetail 初期値より大きいデータ"
                );
                break;
              } else if (
                pred.stg != null &&
                stg > pred.stg + state.riverWarnConfig.predstgValue
              ) {
                // 初期値より小さい場合は、2
                tendency = 2;
                isNoData = false;
                Logger.debug(
                  "[RiverWarn]mut - setSelectedRwDetail 初期値より小さいデータ"
                );
              }
            }
            if (isNoData) {
              // 予測水位がない場合は「3:データなし」を設定
              obs.tendency = 3;
            } else {
              // 予測水位がある場合
              obs.tendency = tendency;
            }
            Logger.debug(
              "[RiverWarn]mut - setSelectedRwDetail tendency = " + tendency
            );
          }
        }
      }
      if (rwFlg) {
        state.selectedAnnNo = rw[0].annNo;
        state.selectedAnnIdx = 0;
        Logger.debug(
          "[RiverWarn]mut - setSelectedRwDetail selectedAnnNo:" +
            state.selectedAnnNo
        );
        Logger.debug(
          "[RiverWarn]mut - setSelectedRwDetail selectedAnnIdx:" +
            state.selectedAnnIdx
        );
      }
      let rwBase = rw;
      let cd = 0;
      // マスタの区間コードを代入
      if (type == 10) {
        cd = mt.fldfrCd;
      } else if (type == 11) {
        cd = mt.evstgCd;
      } else if (type == 20) {
        cd = mt.fldctlCd;
      } else if (type == 30) {
        cd = mt.damdschCd;
      }
      state.selectedRwDetail = {
        mt: mt,
        rw: rw,
        rwBase: rwBase,
        cd: cd,
        rwFlg: rwFlg,
      };
      Logger.debug(
        "[RiverWarn]mut - setSelectedRwDetail selectedRwDetail.rwBase:" +
          state.selectedRwDetail.rwBase
      );
    },
    /**
     * 選択中河川予警報リクエストキーを設定
     * @param {*} state
     * @param {*} data
     */
    setSelectedWarnReq(state, data) {
      Logger.debug("[RiverWarn]mut - setSelectedWarnReq()");
      Logger.dir(data);
      state.selectedWarnReq = data;
    },
    /**
     * 選択中河川予警報タイプをstateに設定
     * @param {*} state
     * @param {*} type
     */
    setSelectedWarnType(state, type) {
      Logger.debug("[RiverWarn]mut - setSelectedWarnType(state," + type + ")");
      state.selectedWarnType = type;
    },
    /**
     * 選択中河川予警報発表番号設定
     * @param {*} state
     * @param {*} annNo
     */
    setSelectedAnnNo(state, annNo) {
      Logger.debug("[RiverWarn]mut - setSelectedAnnNo(state," + annNo + ")");
      for (var idx = 0; idx < state.selectedRwDetail.rw.length; idx++) {
        if (state.selectedRwDetail.rw[idx].annNo == annNo) {
          state.selectedAnnIdx = idx;
          state.selectedAnnNo = annNo;
          break;
        }
      }
    },
    /**
     * 選択中河川予警報発表インデックス設定
     * @param {*} state
     * @param {*} annIdx
     */
    setSelectedAnnIdx(state, annIdx) {
      Logger.debug("[RiverWarn]mut - setSelectedAnnIdx(state," + annIdx + ")");
      state.selectedAnnIdx = annIdx;
      state.selectedAnnNo = state.selectedRwDetail.rw[annIdx].annNo;
    },
    /** 表示範囲の河川予警報GeoJson
     * @param {*} state
     * @param {*} riverWarnLines
     */
    setRiverWarnLocation(state, riverWarnLines) {
      Logger.debug("[RiverWarn]mut - setRiverWarnLocation(riverWarnLines)");
      Logger.dir(riverWarnLines);
      state.rwGeoJson = riverWarnLines;
    },
    /** 選択中河川予警報GeoJson
     * @param {*} state
     * @param {*} riverWarnLines
     */
    setSelectedRwGeoJson(state, geojson) {
      Logger.debug("[RiverWarn]mut - setSelectedRwGeoJson(geojson)");
      Logger.dir(geojson);
      state.selectedRwGeoJson = geojson;
    },
    /**
     * 概況模式図の表示レベル
     * @param {*} state
     * @param {*} level
     */
    setOverviewLevel(state, level) {
      Logger.debug("[RiverWarn]mut - setOverviewLevel(" + level + ")");
      state.overviewLevel = level;
    },
    /**
     * 概況模式図の選択都道府県
     * @param {*} state
     * @param {*} pref
     */
    setOverviewPref(state, pref) {
      Logger.debug("[RiverWarn]mut - setOverviewPref(" + pref + ")");
      state.overviewPref = pref;
    },

    /**
     * 模式図の状態
     * @param {*} state
     * @param {*} ovState
     */
    setOverviewState(state, ovState) {
      Logger.debug("[RiverWarn]mut - setOverviewState()");
      Logger.dir(ovState);
      state.overviewState = ovState;
    },
    /**
     * 履歴動画準備状態設定
     * @param {*} state
     * @param {*} prepStatus 履歴動画再生状態
     */
    setHistoryPlayPrepStatus(state, prepStatus) {
      Logger.debug(
        "[RiverWarn]mut - setHistoryPlayPrepStatus(" + prepStatus + ")"
      );
      state.historyPlayPrepStatus = prepStatus;
    },
    /** 河川予警報存在フラグを更新 */
    setRwExistenceFlg(state, flg) {
      Logger.debug("[RiverWarn]mut - setRwExistenceFlg(" + flg + ")");
      state.rwExistenceFlg = flg;
    },
  },
  actions: makeCancellable({
    /**
     * 高アクセス対応
     * 河川予警報一覧(全体)取得
     * @param {*} param0
     * @param appTime 対象日時
     */
    async getRwListFull(
      { commit },
      { appTime, minlat, minlon, maxlat, maxlon, zm, townsAcqTime }
    ) {
      Logger.debug(
        "[RiverWarn]act - getRwListFull({*},{" +
          appTime +
          "," +
          minlat +
          "," +
          minlon +
          "," +
          maxlat +
          "," +
          maxlon +
          "," +
          zm +
          "," +
          townsAcqTime +
          "})"
      );
      let fldfr = [];
      let damdsch = [];
      let fldctl = [];
      // 都道府県判定リスト
      const {
        data: prefData,
        prefError,
      } = await MapJsonRepository.getPrefList();
      Logger.debug("[RiverWarn] getPrefList()");
      let prefs = [];
      if (!prefError) {
        var prefJudgeList = prefData.prefs;
      }
      prefJudgeList.forEach((pref) => {
        // 取得範囲内の都道府県に絞る
        let pushFlg = true;
        // 小数点計算の誤差を無くすため10*9倍にして計算する
        if (pref.maxLat * Math.pow(10, 9) < minlat * Math.pow(10, 9)) {
          pushFlg = false;
        } else if (pref.maxLon * Math.pow(10, 9) < minlon * Math.pow(10, 9)) {
          pushFlg = false;
        } else if (pref.minLat * Math.pow(10, 9) > maxlat * Math.pow(10, 9)) {
          pushFlg = false;
        } else if (pref.minLon * Math.pow(10, 9) > maxlon * Math.pow(10, 9)) {
          pushFlg = false;
        }
        if (pushFlg) {
          prefs.push(pref.prefCd);
        }
      });
      if (zm < 11) {
        // JSONからデータ取得
        for (var prefCd of prefs) {
          const { data } = await RiverWarnJsonRepository.getRiverWarnPref(
            prefCd,
            appTime
          );
          if (data != null) {
            let fldfrList = data.fldfr;
            let damdschList = data.damdsch;
            let fldctlList = data.fldctl;
            let fldfrSelect = [];
            for (let i = 0; i < fldfrList.length; i++) {
              if (fldfrList[i].lvl >= 0) {
                // 全部比較して、コードが重複してなければ登録する
                let isEntry = true;
                for (let x = 0; x < fldfr.length; x++) {
                  if (fldfr[x].cd === fldfrList[i].cd) {
                    isEntry = false;
                    break;
                  }
                }
                if (isEntry) {
                  fldfrSelect.push(fldfrList[i]);
                }
              }
            }
            // 危険度レベルが0は取得しない。
            for (let rx = 0; rx < fldfrSelect.length; rx++) {
              // if (fldfrSelect[rx].lvl == 0) {
              //   continue;
              // }
              fldfr.push(fldfrSelect[rx]);
            }
            let damdschSelect = [];
            for (let d = 0; d < damdschList.length; d++) {
              if (damdschList[d].damdschLvl >= 0) {
                let isEntry = true;
                for (let x = 0; x < damdsch.length; x++) {
                  if (damdsch[x].damdschCd === damdschList[d].damdschCd) {
                    isEntry = false;
                    break;
                  }
                }
                if (isEntry) {
                  damdschSelect.push(damdschList[d]);
                }
              }
            }
            // 危険度レベルが0で種別コードが101以上の場合は取得しない。
            for (let dx = 0; dx < damdschSelect.length; dx++) {
              // if (
              //   damdschSelect[dx].damdschLvl == 0 &&
              //   damdschSelect[dx].damdschKnd >= 101
              // ) {
              //   continue;
              // }
              damdsch.push(damdschSelect[dx]);
            }
            let fldctlSelect = [];
            for (let f = 0; f < fldctlList.length; f++) {
              if (fldctlList[f].fldctlLvl >= 0) {
                let isEntry = true;
                for (let x = 0; x < fldctl.length; x++) {
                  if (fldctl[x].fldctlCd === fldctlList[f].fldctlCd) {
                    isEntry = false;
                    break;
                  }
                }
                if (isEntry) {
                  fldctlSelect.push(fldctlList[f]);
                }
              }
            }
            // 危険度レベルが0で種別コードが101以上か、種別コード40は取得しない。
            for (let lx = 0; lx < fldctlSelect.length; lx++) {
              if (
                (fldctlSelect[lx].fldctlLvl == 0 &&
                  fldctlSelect[lx].fldctlKnd >= 101) ||
                fldctlSelect[lx].fldctlKnd == 40
              ) {
                continue;
              }
              fldctl.push(fldctlSelect[lx]);
            }
          }
          Logger.debug("[RiverWarn]act - getRwListFull");
        }
      } else {
        // 市町村判定リスト
        const {
          data: townData,
          townError,
        } = await MapJsonRepository.getTownList();
        Logger.debug("[RiverWarn] getTownList()");
        let towns = [];
        if (!townError) {
          var twonJudgeList = townData.towns;
        }
        twonJudgeList.forEach((town) => {
          // 取得範囲内の市町村に絞る
          let pushFlg = true;
          // 小数点計算の誤差を無くすため10*9倍にして計算する
          if (town.maxLat * Math.pow(10, 9) < minlat * Math.pow(10, 9)) {
            pushFlg = false;
          } else if (town.maxLon * Math.pow(10, 9) < minlon * Math.pow(10, 9)) {
            pushFlg = false;
          } else if (town.minLat * Math.pow(10, 9) > maxlat * Math.pow(10, 9)) {
            pushFlg = false;
          } else if (town.minLon * Math.pow(10, 9) > maxlon * Math.pow(10, 9)) {
            pushFlg = false;
          }
          if (pushFlg) {
            towns.push(town.twnCd);
          }
        });
        let rwList = [];
        // JSONからデータ取得
        for (let prefCd of prefs) {
          const { data } = await RiverWarnJsonRepository.getRiverWarnPref(
            prefCd,
            appTime
          );
          // twnを抽出したリストを作成
          if (data != null) {
            let list = [];
            for (let twnIdx = 0; twnIdx < data.twn.length; twnIdx++) {
              list.push(data.twn[twnIdx]);
            }
            // 取得ファイルと地図の市町村が同じ市町村コードの場合、リストに追加
            for (let idx = 0; idx < list.length; idx++) {
              for (let t = 0; t < towns.length; t++) {
                if (towns[t] === list[idx].twnCd) {
                  rwList.push(list[idx]);
                }
              }
            }
          }
        }
        let damdschList = [];
        let fldctlList = [];
        let fldfrList = [];
        // リストを予警報別に分ける
        for (let rwIdx = 0; rwIdx < rwList.length; rwIdx++) {
          if (rwList[rwIdx].fldfr != null) {
            fldfrList = rwList[rwIdx].fldfr;
          }
          if (rwList[rwIdx].damdsch != null) {
            damdschList = rwList[rwIdx].damdsch;
          }
          if (rwList[rwIdx].fldctl != null) {
            fldctlList = rwList[rwIdx].fldctl;
          }

          let fldfrSelect = [];
          for (let i = 0; i < fldfrList.length; i++) {
            if (fldfrList[i].lvl >= 0) {
              // 全部比較して、コードが重複してなければ登録する
              let isEntry = true;
              for (let x = 0; x < fldfr.length; x++) {
                if (fldfr[x].cd === fldfrList[i].cd) {
                  isEntry = false;
                  break;
                }
              }
              if (isEntry) {
                fldfrSelect.push(fldfrList[i]);
              }
            }
          }
          // 危険度レベルが0は取得しない。
          for (let rx = 0; rx < fldfrSelect.length; rx++) {
            // if (fldfrSelect[rx].lvl == 0) {
            //   continue;
            // }
            fldfr.push(fldfrSelect[rx]);
          }
          let damdschSelect = [];
          for (let d = 0; d < damdschList.length; d++) {
            if (damdschList[d].damdschLvl >= 0) {
              let isEntry = true;
              for (let x = 0; x < damdsch.length; x++) {
                if (damdsch[x].damdschCd === damdschList[d].damdschCd) {
                  isEntry = false;
                  break;
                }
              }
              if (isEntry) {
                damdschSelect.push(damdschList[d]);
              }
            }
          }
          // 危険度レベルが0で種別コードが101以上の場合は取得しない。
          for (let dx = 0; dx < damdschSelect.length; dx++) {
            // if (
            //   damdschSelect[dx].damdschLvl == 0 &&
            //   damdschSelect[dx].damdschKnd >= 101
            // ) {
            //   continue;
            // }
            damdsch.push(damdschSelect[dx]);
          }
          let fldctlSelect = [];
          for (let f = 0; f < fldctlList.length; f++) {
            if (fldctlList[f].fldctlLvl >= 0) {
              let isEntry = true;
              for (let x = 0; x < fldctl.length; x++) {
                if (fldctl[x].fldctlCd === fldctlList[f].fldctlCd) {
                  isEntry = false;
                  break;
                }
              }
              if (isEntry) {
                fldctlSelect.push(fldctlList[f]);
              }
            }
          }
          // 危険度レベルが0で種別コードが101以上か、種別コード40は取得しない。
          for (let lx = 0; lx < fldctlSelect.length; lx++) {
            if (
              (fldctlSelect[lx].fldctlLvl == 0 &&
                fldctlSelect[lx].fldctlKnd >= 101) ||
              fldctlSelect[lx].fldctlKnd == 40
            ) {
              continue;
            }
            fldctl.push(fldctlSelect[lx]);
          }
        }
        Logger.debug("[RiverWarn]act - getRwListFull");
      }
      //洪水予報と水位周知河川情報のソートの並び替え
      fldfr.sort(function(a, b) {
        if (a.lvl < b.lvl) return 1;
        if (a.lvl > b.lvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      //ダム放流通知のソートの並び替え
      damdsch.sort(function(a, b) {
        if (a.damdschLvl < b.damdschLvl) return 1;
        if (a.damdschLvl > b.damdschLvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      // 水防警報のソートの並び替え
      fldctl.sort(function(a, b) {
        if (a.fldctlLvl < b.fldctlLvl) return 1;
        if (a.fldctlLvl > b.fldctlLvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      // 洪水予報マスタ情報を取得
      var fldfrCdList = [];
      for (let i = 0; i < fldfr.length; i++) {
        if (fldfr[i].type == "fldfr") {
          fldfrCdList.push(fldfr[i].cd);
        }
      }
      for (let fldfrCd of fldfrCdList) {
        const {
          data: mtFldfr,
        } = await RiverWarnJsonRepository.getSelectedMtFldfr(fldfrCd);
        if (mtFldfr != null) {
          for (let i = 0; i < fldfr.length; i++) {
            // 同じ区間の洪水予報にマスタ情報を追加
            if (fldfr[i].cd == mtFldfr.fldfrCd) {
              Object.assign(fldfr[i], mtFldfr);
            }
          }
        }
      }
      // 水位周知河川情報マスタ情報を取得
      var evstgCdList = [];
      for (let i = 0; i < fldfr.length; i++) {
        if (fldfr[i].type == "evstg") {
          evstgCdList.push(fldfr[i].cd);
        }
      }
      for (let evstgCd of evstgCdList) {
        const {
          data: mtEvstg,
        } = await RiverWarnJsonRepository.getSelectedMtEvstg(evstgCd);
        if (mtEvstg != null) {
          for (let i = 0; i < fldfr.length; i++) {
            // 同じ区間の水位周知河川情報にマスタ情報を追加
            if (fldfr[i].cd == mtEvstg.evstgCd) {
              Object.assign(fldfr[i], mtEvstg);
            }
          }
        }
      }
      // ダム放流通知マスタ情報を取得
      var damdschCdList = [];
      for (let i = 0; i < damdsch.length; i++) {
        damdschCdList.push(damdsch[i].damdschCd);
      }
      for (let damdschCd of damdschCdList) {
        const {
          data: mtDamdsch,
        } = await RiverWarnJsonRepository.getSelectedMtDamdsch(damdschCd);
        if (mtDamdsch != null) {
          for (let i = 0; i < damdsch.length; i++) {
            // 同じ区間のダム放流通知にマスタ情報を追加
            if (damdsch[i].damdschCd == mtDamdsch.damdschCd) {
              Object.assign(damdsch[i], mtDamdsch);
            }
          }
        }
      }
      // 水防警報マスタ情報を取得
      var fldctlCdList = [];
      for (let i = 0; i < fldctl.length; i++) {
        fldctlCdList.push(fldctl[i].fldctlCd);
      }
      for (let fldctlCd of fldctlCdList) {
        const {
          data: mtFldctl,
        } = await RiverWarnJsonRepository.getSelectedMtFldctl(fldctlCd);
        if (mtFldctl != null) {
          for (let i = 0; i < fldctl.length; i++) {
            // 同じ区間の水防警報にマスタ情報を追加
            if (fldctl[i].fldctlCd == mtFldctl.fldctlCd) {
              Object.assign(fldctl[i], mtFldctl);
            }
          }
        }
      }
      var rw = { fldfr, damdsch, fldctl };
      // パラメータをストアに格納
      commit("setRiverWarnsFullParam", {
        dispTime: appTime,
        townsAcqTime: townsAcqTime,
      });
      // 取得した予警報情報をストアに格納
      commit("setRiverWarnsFullList", rw);
    },
    /**
     * 高アクセス対応
     * 河川予警報一覧(全体) の地方取得
     * @param {*} param0
     * @param appTime 対象日時
     * @param prefs 都道府県リスト
     */
    async getRiverWarnsPrefs({ commit }, { appTime, prefs, townsAcqTime }) {
      Logger.debug(
        "[RiverWarn]act - getRiverWarnsPrefs({*},{" +
          appTime +
          "," +
          prefs +
          "," +
          townsAcqTime +
          "})"
      );
      Logger.dir(prefs);
      let fldfr = [];
      let damdsch = [];
      let fldctl = [];
      for (let prefCd of prefs) {
        const { data } = await RiverWarnJsonRepository.getRiverWarnPref(
          prefCd,
          appTime
        );
        if (data != null) {
          let fldfrList = data.fldfr;
          let damdschList = data.damdsch;
          let fldctlList = data.fldctl;
          let fldfrSelect = [];
          for (let i = 0; i < fldfrList.length; i++) {
            if (fldfrList[i].lvl >= 0) {
              // 全部比較して、コードが重複してなければ登録する
              let isEntry = true;
              for (let x = 0; x < fldfr.length; x++) {
                if (fldfr[x].cd === fldfrList[i].cd) {
                  isEntry = false;
                  break;
                }
              }
              if (isEntry) {
                fldfrSelect.push(fldfrList[i]);
              }
            }
          }
          // 危険度レベルが0は取得しない。
          for (let rx = 0; rx < fldfrSelect.length; rx++) {
            // if (fldfrSelect[rx].lvl == 0) {
            //   continue;
            // }
            fldfr.push(fldfrSelect[rx]);
          }
          let damdschSelect = [];
          for (let d = 0; d < damdschList.length; d++) {
            if (damdschList[d].damdschLvl >= 0) {
              let isEntry = true;
              for (let x = 0; x < damdsch.length; x++) {
                if (damdsch[x].damdschCd === damdschList[d].damdschCd) {
                  isEntry = false;
                  break;
                }
              }
              if (isEntry) {
                damdschSelect.push(damdschList[d]);
              }
            }
          }
          // 危険度レベルが0で種別コードが101以上の場合は取得しない。
          for (let dx = 0; dx < damdschSelect.length; dx++) {
            // if (
            //   damdschSelect[dx].damdschLvl == 0 &&
            //   damdschSelect[dx].damdschKnd >= 101
            // ) {
            //   continue;
            // }
            damdsch.push(damdschSelect[dx]);
          }
          let fldctlSelect = [];
          for (let f = 0; f < fldctlList.length; f++) {
            if (fldctlList[f].fldctlLvl >= 0) {
              let isEntry = true;
              for (let x = 0; x < fldctl.length; x++) {
                if (fldctl[x].fldctlCd === fldctlList[f].fldctlCd) {
                  isEntry = false;
                  break;
                }
              }
              if (isEntry) {
                fldctlSelect.push(fldctlList[f]);
              }
            }
          }
          // 危険度レベルが0で種別コードが101以上か、種別コード40は取得しない。
          for (let lx = 0; lx < fldctlSelect.length; lx++) {
            if (
              (fldctlSelect[lx].fldctlLvl == 0 &&
                fldctlSelect[lx].fldctlKnd >= 101) ||
              fldctlSelect[lx].fldctlKnd == 40
            ) {
              continue;
            }
            fldctl.push(fldctlSelect[lx]);
          }
        }
        Logger.debug("[RiverWarn]act - getRiverWarnsPrefs");
      }
      //洪水予報と水位周知河川情報のソートの並び替え
      fldfr.sort(function(a, b) {
        if (a.lvl < b.lvl) return 1;
        if (a.lvl > b.lvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      //ダム放流通知のソートの並び替え
      damdsch.sort(function(a, b) {
        if (a.damdschLvl < b.damdschLvl) return 1;
        if (a.damdschLvl > b.damdschLvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      // 水防警報のソートの並び替え
      fldctl.sort(function(a, b) {
        if (a.fldctlLvl < b.fldctlLvl) return 1;
        if (a.fldctlLvl > b.fldctlLvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      // 洪水予報マスタ情報を取得
      let fldfrCdList = [];
      for (let i = 0; i < fldfr.length; i++) {
        if (fldfr[i].type == "fldfr") {
          fldfrCdList.push(fldfr[i].cd);
        }
      }
      for (let fldfrCd of fldfrCdList) {
        const {
          data: mtFldfr,
        } = await RiverWarnJsonRepository.getSelectedMtFldfr(fldfrCd);
        if (mtFldfr != null) {
          for (let i = 0; i < fldfr.length; i++) {
            // 同じ区間の洪水予報にマスタ情報を追加
            if (fldfr[i].cd == mtFldfr.fldfrCd) {
              Object.assign(fldfr[i], mtFldfr);
            }
          }
        }
      }
      // 水位周知河川情報マスタ情報を取得
      let evstgCdList = [];
      for (let i = 0; i < fldfr.length; i++) {
        if (fldfr[i].type == "evstg") {
          evstgCdList.push(fldfr[i].cd);
        }
      }
      for (let evstgCd of evstgCdList) {
        const {
          data: mtEvstg,
        } = await RiverWarnJsonRepository.getSelectedMtEvstg(evstgCd);
        if (mtEvstg != null) {
          for (let i = 0; i < fldfr.length; i++) {
            // 同じ区間の水位周知河川情報にマスタ情報を追加
            if (fldfr[i].cd == mtEvstg.evstgCd) {
              Object.assign(fldfr[i], mtEvstg);
            }
          }
        }
      }
      // ダム放流通知マスタ情報を取得
      let damdschCdList = [];
      for (let i = 0; i < damdsch.length; i++) {
        damdschCdList.push(damdsch[i].damdschCd);
      }
      for (let damdschCd of damdschCdList) {
        const {
          data: mtDamdsch,
        } = await RiverWarnJsonRepository.getSelectedMtDamdsch(damdschCd);
        if (mtDamdsch != null) {
          for (let i = 0; i < damdsch.length; i++) {
            // 同じ区間のダム放流通知にマスタ情報を追加
            if (damdsch[i].damdschCd == mtDamdsch.damdschCd) {
              Object.assign(damdsch[i], mtDamdsch);
            }
          }
        }
      }
      // 水防警報マスタ情報を取得
      let fldctlCdList = [];
      for (let i = 0; i < fldctl.length; i++) {
        fldctlCdList.push(fldctl[i].fldctlCd);
      }
      for (let fldctlCd of fldctlCdList) {
        const {
          data: mtFldctl,
        } = await RiverWarnJsonRepository.getSelectedMtFldctl(fldctlCd);
        if (mtFldctl != null) {
          for (let i = 0; i < fldctl.length; i++) {
            // 同じ区間の水防警報にマスタ情報を追加
            if (fldctl[i].fldctlCd == mtFldctl.fldctlCd) {
              Object.assign(fldctl[i], mtFldctl);
            }
          }
        }
      }
      let rw = { fldfr, damdsch, fldctl };
      // パラメータをストアに格納
      commit("setRiverWarnsFullParam", {
        dispTime: appTime,
        townsAcqTime: townsAcqTime,
      });
      // 取得した予警報情報をストアに格納
      commit("setRiverWarnsFullList", rw);
    },
    /**
     * 高アクセス対応
     * 河川予警報危険度取得
     * @param {*} param0
     * @param appTime 対象日時
     */
    async getRiverWarnsLvl({ commit }, { appTime }) {
      Logger.debug("[RiverWarn]act - getRiverWarnsLvl({*},{" + appTime + "})");
      // Jsonからデータ取得
      const { data } = await RiverWarnJsonRepository.getRiverWarnsLvl(appTime);
      // パラメータをストアに格納
      commit("setRiverWarnsParamDispTime", appTime);
      // 取得した概況模式図情報をストアに格納
      let ovState = {
        pref: {
          fldfr: data.pref.fldfr,
          fldctl: data.pref.fldctl,
          damdsch: data.pref.damdsch,
        },
        area: {
          fldfr: data.area.fldfr,
          fldctl: data.area.fldctl,
          damdsch: data.area.damdsch,
        },
      };
      commit("setOverviewState", ovState);
    },
    /**
     * 高アクセス対応
     * 河川予警報一覧（河川予警報一覧画面）取得
     * @param {*} param0
     * @param appTime 対象日時
     * @param prefs 都道府県リスト
     * @param towns 市町村リスト
     */
    getRwListByTwn: takeLatest(async function(
      { commit },
      { appTime, prefs, towns, townsAcqTime }
    ) {
      Logger.debug(
        "[RiverWarn]act - getRwListByTwn({*},{" +
          appTime +
          "," +
          prefs +
          "," +
          towns +
          "," +
          townsAcqTime +
          "})"
      );
      let fldfr = [];
      let damdsch = [];
      let fldctl = [];
      // 市町村コードリスト作成
      let townList = [];
      for (let twon of towns) {
        townList.push(twon.id);
      }
      // 都道府県コードリスト作成
      let prefList = [];
      for (let pref of prefs) {
        prefList.push(pref.id);
      }
      let rwList = [];
      // Jsonファイルからデータ取得
      for (let prefCd of prefList) {
        const { data } = await RiverWarnJsonRepository.getRiverWarnPref(
          prefCd,
          appTime
        );
        // twnを抽出したリストを作成
        let list = [];
        if (data != null) {
          for (let twnIdx = 0; twnIdx < data.twn.length; twnIdx++) {
            list.push(data.twn[twnIdx]);
          }
          // 取得ファイルと地図の市町村が同じ市町村コードの場合、リストに追加
          for (let idx = 0; idx < list.length; idx++) {
            for (let t = 0; t < townList.length; t++) {
              if (townList[t] == list[idx].twnCd) {
                rwList.push(list[idx]);
              }
            }
          }
          let damdschList = [];
          let fldctlList = [];
          let fldfrList = [];
          // リストを予警報別に分ける
          for (let rwIdx = 0; rwIdx < rwList.length; rwIdx++) {
            if (rwList[rwIdx].fldfr != null) {
              for (let idx = 0; idx < rwList[rwIdx].fldfr.length; idx++) {
                fldfrList.push(rwList[rwIdx].fldfr[idx]);
              }
            }
            if (rwList[rwIdx].damdsch != null) {
              for (let idx = 0; idx < rwList[rwIdx].damdsch.length; idx++) {
                damdschList.push(rwList[rwIdx].damdsch[idx]);
              }
              damdschList = rwList[rwIdx].damdsch;
            }
            if (rwList[rwIdx].fldctl != null) {
              for (let idx = 0; idx < rwList[rwIdx].fldctl.length; idx++) {
                fldctlList.push(rwList[rwIdx].fldctl[idx]);
              }
              fldctlList = rwList[rwIdx].fldctl;
            }
          }
          let fldfrSelect = [];
          for (let i = 0; i < fldfrList.length; i++) {
            if (fldfrList[i] != null) {
              let isEntry = true;
              // 全部比較して、コードが重複してなければ登録する
              for (let x = 0; x < fldfrSelect.length; x++) {
                if (fldfrSelect[x].cd === fldfrList[i].cd) {
                  isEntry = false;
                  break;
                }
              }
              // fldfrのコードと被らなければ登録する。
              for (let idx = 0; idx < fldfr.length; idx++) {
                if (fldfr[idx].cd === fldfrList[i].cd) {
                  isEntry = false;
                  break;
                }
              }
              if (isEntry) {
                fldfrSelect.push(fldfrList[i]);
              }
            }
          }
          // 危険度レベルが0で、種別コードが101以上は取得しない。
          for (let rx = 0; rx < fldfrSelect.length; rx++) {
            // if (fldfrSelect[rx].lvl == 0 && fldfrSelect[rx].knd >= 101) {
            //   continue;
            // }
            fldfr.push(fldfrSelect[rx]);
          }
          let damdschSelect = [];
          for (let d = 0; d < damdschList.length; d++) {
            // 簡易版の場合は洪水貯留操作以上のみ抽出
            if (
              damdschList[d] != null &&
              ((global.KWB_MODE != "reduction" &&
                damdschList[d].damdschLvl >= 0) ||
                (global.KWB_MODE == "reduction" &&
                  damdschList[d].damdschLvl >= 50))
            ) {
              let isEntry = true;
              for (let x = 0; x < damdschSelect.length; x++) {
                if (damdschSelect[x].damdschCd === damdschList[d].damdschCd) {
                  isEntry = false;
                  break;
                }
              }
              // damdschのコードと被らなければ登録する。
              for (let idx = 0; idx < damdsch.length; idx++) {
                if (damdsch[idx].damdschCd === damdschList[d].damdschCd) {
                  isEntry = false;
                  break;
                }
              }
              if (isEntry) {
                damdschSelect.push(damdschList[d]);
              }
            }
          }
          // 危険度レベルが0で、種別コードが101以上は取得しない。
          for (let dx = 0; dx < damdschSelect.length; dx++) {
            // if (
            //   damdschSelect[dx].damdschLvl == 0 &&
            //   damdschSelect[dx].damdschKnd >= 101
            // ) {
            //   continue;
            // }
            damdsch.push(damdschSelect[dx]);
          }
          let fldctlSelect = [];
          for (let f = 0; f < fldctlList.length; f++) {
            if (fldctlList[f] != null) {
              let isEntry = true;
              for (let x = 0; x < fldctlSelect.length; x++) {
                if (fldctlSelect[x].fldctlCd === fldctlList[f].fldctlCd) {
                  isEntry = false;
                  break;
                }
              }
              // fldctlのコードと被らなければ登録する。
              for (let idx = 0; idx < fldctl.length; idx++) {
                if (fldctl[idx].fldctlCd === fldctlList[f].fldctlCd) {
                  isEntry = false;
                  break;
                }
              }
              if (isEntry) {
                fldctlSelect.push(fldctlList[f]);
              }
            }
          }
          // 危険度レベルが0で、種別コードが101以上は取得しない。
          for (let lx = 0; lx < fldctlSelect.length; lx++) {
            // if (
            //   fldctlSelect[lx].fldctlLvl == 0 &&
            //   fldctlSelect[lx].fldctlKnd >= 101
            // ) {
            //   continue;
            // }
            fldctl.push(fldctlSelect[lx]);
          }
        }
      }
      Logger.debug("[RiverWarn]act - getRwListByTwn");

      //洪水予報と水位周知河川情報のソートの並び替え
      fldfr.sort(function(a, b) {
        if (a.lvl < b.lvl) return 1;
        if (a.lvl > b.lvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      //ダム放流通知のソートの並び替え
      damdsch.sort(function(a, b) {
        if (a.damdschLvl < b.damdschLvl) return 1;
        if (a.damdschLvl > b.damdschLvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      // 水防警報のソートの並び替え
      fldctl.sort(function(a, b) {
        if (a.fldctlLvl < b.fldctlLvl) return 1;
        if (a.fldctlLvl > b.fldctlLvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      let rw = { fldfr, damdsch, fldctl };
      // パラメータをストアに格納
      commit("setRiverWarnsParam", {
        dispTime: appTime,
        townsAcqTime: townsAcqTime,
      });
      // 取得した予警報情報をストアに格納
      commit("setRiverWarnsList", rw);
    }),
    /**
     * 高アクセス対応
     * 河川予警報一覧（概況画面） 取得（ 市町村コードリスト）
     * @param {*} param0
     * @param appTime 対象日時
     * @param prefs 都道府県リスト
     * @param towns 市町村リスト
     */
    getRiverWarnsListTwn: takeLatest(async function(
      { commit },
      { appTime, prefs, towns, townsAcqTime }
    ) {
      Logger.debug(
        "[RiverWarn]act - getRiverWarnsListTwn({*},{" +
          appTime +
          "," +
          prefs +
          "," +
          towns +
          "," +
          townsAcqTime +
          "})"
      );
      let fldfr = [];
      let damdsch = [];
      let fldctl = [];
      // 市町村コードリスト作成
      let townList = [];
      for (let twon of towns) {
        townList.push(twon.id);
      }
      // 都道府県コードリスト作成
      let prefList = [];
      for (let pref of prefs) {
        prefList.push(pref.id);
      }
      let rwList = [];
      // Jsonファイルからデータ取得
      for (let prefCd of prefList) {
        const { data } = await RiverWarnJsonRepository.getRiverWarnPref(
          prefCd,
          appTime
        );
        // twnを抽出したリストを作成
        if (data != null) {
          let list = [];
          for (let twnIdx = 0; twnIdx < data.twn.length; twnIdx++) {
            list.push(data.twn[twnIdx]);
          }
          // 取得ファイルと地図の市町村が同じ市町村コードの場合、リストに追加
          for (let idx = 0; idx < list.length; idx++) {
            for (let t = 0; t < townList.length; t++) {
              if (townList[t] === list[idx].twnCd) {
                rwList.push(list[idx]);
              }
            }
          }
        }
      }
      let damdschList = [];
      let fldctlList = [];
      let fldfrList = [];
      // リストを予警報別に分ける
      for (let rwIdx = 0; rwIdx < rwList.length; rwIdx++) {
        if (rwList[rwIdx].fldfr != null) {
          fldfrList = rwList[rwIdx].fldfr;
        }
        if (rwList[rwIdx].damdsch != null) {
          damdschList = rwList[rwIdx].damdsch;
        }
        if (rwList[rwIdx].fldctl != null) {
          fldctlList = rwList[rwIdx].fldctl;
        }
        let fldfrSelect = [];
        for (let i = 0; i < fldfrList.length; i++) {
          if (fldfrList[i].lvl >= 0) {
            // 全部比較して、コードが重複してなければ登録する
            let isEntry = true;
            for (let x = 0; x < fldfr.length; x++) {
              if (fldfr[x].cd === fldfrList[i].cd) {
                isEntry = false;
                break;
              }
            }
            if (isEntry) {
              fldfrSelect.push(fldfrList[i]);
            }
          }
        }
        // 危険度レベルが0は取得しない。
        for (let rx = 0; rx < fldfrSelect.length; rx++) {
          // if (fldfrSelect[rx].lvl == 0) {
          //   continue;
          // }
          fldfr.push(fldfrSelect[rx]);
        }
        let damdschSelect = [];
        for (let d = 0; d < damdschList.length; d++) {
          if (damdschList[d].damdschLvl >= 0) {
            let isEntry = true;
            for (let x = 0; x < damdsch.length; x++) {
              if (damdsch[x].damdschCd === damdschList[d].damdschCd) {
                isEntry = false;
                break;
              }
            }
            if (isEntry) {
              damdschSelect.push(damdschList[d]);
            }
          }
        }

        // 危険度レベルが0で、種別コードが101以上の場合はは取得しない。
        for (let dx = 0; dx < damdschSelect.length; dx++) {
          // if (
          //   damdschSelect[dx].damdschLvl == 0 &&
          //   damdschSelect[dx].damdschKnd >= 101
          // ) {
          //   continue;
          // }
          damdsch.push(damdschSelect[dx]);
        }
        let fldctlSelect = [];
        for (let f = 0; f < fldctlList.length; f++) {
          if (fldctlList[f].fldctlLvl >= 0) {
            let isEntry = true;
            for (let x = 0; x < fldctl.length; x++) {
              if (fldctl[x].fldctlCd === fldctlList[f].fldctlCd) {
                isEntry = false;
                break;
              }
            }
            if (isEntry) {
              fldctlSelect.push(fldctlList[f]);
            }
          }
        }
        // 危険度レベルが0で種別コードが101以上か、種別コード40は取得しない。
        for (let lx = 0; lx < fldctlSelect.length; lx++) {
          if (
            (fldctlSelect[lx].fldctlLvl == 0 &&
              fldctlSelect[lx].fldctlKnd >= 101) ||
            fldctlSelect[lx].fldctlKnd == 40
          ) {
            continue;
          }
          fldctl.push(fldctlSelect[lx]);
        }
        Logger.debug("[RiverWarn]act - getRiverWarnsListTwn");
      }
      //洪水予報と水位周知河川情報のソートの並び替え
      fldfr.sort(function(a, b) {
        if (a.lvl < b.lvl) return 1;
        if (a.lvl > b.lvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      //ダム放流通知のソートの並び替え
      damdsch.sort(function(a, b) {
        if (a.damdschLvl < b.damdschLvl) return 1;
        if (a.damdschLvl > b.damdschLvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      // 水防警報のソートの並び替え
      fldctl.sort(function(a, b) {
        if (a.fldctlLvl < b.fldctlLvl) return 1;
        if (a.fldctlLvl > b.fldctlLvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      var rw = { fldfr, damdsch, fldctl };
      // パラメータをストアに格納
      commit("setRiverWarnsOvParam", {
        dispTime: appTime,
        townsAcqTime: townsAcqTime,
      });
      // 取得した予警報情報をストアに格納
      commit("setRiverWarnsOvList", rw);
    }),
    /**
     * 高アクセス対応
     * 河川予警報一覧（ 河川予警報一覧画面） 取得（ 都道府県コードリスト）
     * @param {*} param0
     * @param appTime 対象日時
     * @param prefs 都道府県リスト
     */
    getRwListByPref: takeLatest(async function(
      { commit },
      { appTime, prefs, townsAcqTime }
    ) {
      Logger.debug(
        "[RiverWarn]act - getRwListByPref({*},{" +
          appTime +
          "," +
          prefs +
          "," +
          townsAcqTime +
          "})"
      );
      Logger.dir(prefs);
      let fldfr = [];
      let damdsch = [];
      let fldctl = [];
      // Jsonファイルからデータ取得
      if (prefs.length > 0) {
        var list = [];
        for (let pref of prefs) {
          list.push(pref.id);
        }
        for (let prefCd of list) {
          const { data } = await RiverWarnJsonRepository.getRiverWarnPref(
            prefCd,
            appTime
          );
          if (data != null) {
            let fldfrList = data.fldfr;
            let damdschList = data.damdsch;
            let fldctlList = data.fldctl;
            let fldfrSelect = [];
            // fldfrListのループを回す
            for (let i = 0; i < fldfrList.length; i++) {
              // 空でない場合、処理を行う。
              if (fldfrList[i] != null) {
                // 全部比較して、コードが重複してなければ登録する
                let isEntry = true;
                for (let x = 0; x < fldfr.length; x++) {
                  if (fldfr[x].cd === fldfrList[i].cd) {
                    isEntry = false;
                    break;
                  }
                }
                if (isEntry) {
                  fldfrSelect.push(fldfrList[i]);
                }
              }
            }
            // 危険度レベルが0で、種別コードが101以上は取得しない。
            for (let rx = 0; rx < fldfrSelect.length; rx++) {
              // if (fldfrSelect[rx].lvl == 0 && fldfrSelect[rx].knd >= 101) {
              //   continue;
              // }
              fldfr.push(fldfrSelect[rx]);
            }
            let damdschSelect = [];
            for (let d = 0; d < damdschList.length; d++) {
              // 簡易版の場合は洪水貯留操作以上のみ抽出
              if (
                damdschList[d] != null
                // &&
                // ((global.KWB_MODE != "reduction" &&
                //   damdschList[d].damdschLvl >= 0) ||
                //   (global.KWB_MODE == "reduction" &&
                //     damdschList[d].damdschLvl >= 50))
              ) {
                let isEntry = true;
                for (let x = 0; x < damdsch.length; x++) {
                  if (damdsch[x].damdschCd === damdschList[d].damdschCd) {
                    isEntry = false;
                    break;
                  }
                }
                if (isEntry) {
                  damdschSelect.push(damdschList[d]);
                }
              }
            }
            // 危険度レベルが0で、種別コードが101以上の場合は取得しない。
            for (let dx = 0; dx < damdschSelect.length; dx++) {
              // if (
              //   damdschSelect[dx].damdschLvl == 0 &&
              //   damdschSelect[dx].damdschKnd >= 101
              // ) {
              //   continue;
              // }
              damdsch.push(damdschSelect[dx]);
            }
            let fldctlSelect = [];
            for (let f = 0; f < fldctlList.length; f++) {
              if (fldctlList[f] != null) {
                let isEntry = true;
                for (let x = 0; x < fldctl.length; x++) {
                  if (fldctl[x].fldctlCd === fldctlList[f].fldctlCd) {
                    isEntry = false;
                    break;
                  }
                }
                if (isEntry) {
                  fldctlSelect.push(fldctlList[f]);
                }
              }
            }
            // 危険度レベルが0で、種別コードが101以上は取得しない。
            for (let lx = 0; lx < fldctlSelect.length; lx++) {
              // if (
              //   fldctlSelect[lx].fldctlLvl == 0 &&
              //   fldctlSelect[lx].fldctlKnd >= 101
              // ) {
              //   continue;
              // }
              fldctl.push(fldctlSelect[lx]);
            }
          }
          Logger.debug("[RiverWarn]act - getRwListByPref");
        }
      }
      //洪水予報と水位周知河川情報のソートの並び替え
      fldfr.sort(function(a, b) {
        if (a.lvl < b.lvl) return 1;
        if (a.lvl > b.lvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });

      //ダム放流通知のソートの並び替え
      damdsch.sort(function(a, b) {
        if (a.damdschLvl < b.damdschLvl) return 1;
        if (a.damdschLvl > b.damdschLvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      // 水防警報のソートの並び替え
      fldctl.sort(function(a, b) {
        if (a.fldctlLvl < b.fldctlLvl) return 1;
        if (a.fldctlLvl > b.fldctlLvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      let rw = { fldfr, damdsch, fldctl };
      // パラメータをストアに格納
      commit("setRiverWarnsParam", {
        dispTime: appTime,
        townsAcqTime: townsAcqTime,
      });
      // 取得した予警報情報をストアに格納
      commit("setRiverWarnsList", rw);
    }),
    /**
     * 高アクセス対応
     * 河川予警報一覧（概況画面） 取得（ 都道府県コードリスト）
     * @param {*} param0
     * @param appTime 対象日時
     * @param prefs 都道府県リスト
     */
    getRiverwarnsListPref: takeLatest(async function(
      { commit },
      { appTime, prefs, townsAcqTime }
    ) {
      Logger.debug(
        "[RiverWarn]act - getRiverwarnsListPref({*},{" +
          appTime +
          "," +
          prefs +
          "," +
          townsAcqTime +
          "})"
      );
      let fldfr = [];
      let damdsch = [];
      let fldctl = [];
      // Jsonファイルからデータ取得
      if (prefs.length > 0) {
        let list = [];
        for (let pref of prefs) {
          list.push(pref.id);
        }
        for (let prefCd of list) {
          const { data } = await RiverWarnJsonRepository.getRiverWarnPref(
            prefCd,
            appTime
          );
          if (data != null) {
            let fldfrList = data.fldfr;
            let damdschList = data.damdsch;
            let fldctlList = data.fldctl;
            let fldfrSelect = [];
            for (let i = 0; i < fldfrList.length; i++) {
              if (fldfrList[i].lvl >= 0) {
                // 全部比較して、コードが重複してなければ登録する
                let isEntry = true;
                for (let x = 0; x < fldfr.length; x++) {
                  if (fldfr[x].cd === fldfrList[i].cd) {
                    isEntry = false;
                    break;
                  }
                }
                if (isEntry) {
                  fldfrSelect.push(fldfrList[i]);
                }
              }
            }
            // 危険度レベルが0は取得しない。
            for (let rx = 0; rx < fldfrSelect.length; rx++) {
              // if (fldfrSelect[rx].lvl == 0) {
              //   continue;
              // }
              fldfr.push(fldfrSelect[rx]);
            }
            let damdschSelect = [];
            for (let d = 0; d < damdschList.length; d++) {
              if (damdschList[d].damdschLvl >= 0) {
                let isEntry = true;
                for (let x = 0; x < damdsch.length; x++) {
                  if (damdsch[x].damdschCd === damdschList[d].damdschCd) {
                    isEntry = false;
                    break;
                  }
                }
                if (isEntry) {
                  damdschSelect.push(damdschList[d]);
                }
              }
            }
            // 危険度レベルが0で、種別コードが101以上の場合は取得しない。
            for (let dx = 0; dx < damdschSelect.length; dx++) {
              // if (
              //   damdschSelect[dx].damdschLvl == 0 &&
              //   damdschSelect[dx].damdschKnd >= 101
              // ) {
              //   continue;
              // }
              damdsch.push(damdschSelect[dx]);
            }
            let fldctlSelect = [];
            for (let f = 0; f < fldctlList.length; f++) {
              if (fldctlList[f].fldctlLvl >= 0) {
                let isEntry = true;
                for (let x = 0; x < fldctl.length; x++) {
                  if (fldctl[x].fldctlCd === fldctlList[f].fldctlCd) {
                    isEntry = false;
                    break;
                  }
                }
                if (isEntry) {
                  fldctlSelect.push(fldctlList[f]);
                }
              }
            }
            // 危険度レベルが0で種別コードが101以上か、種別コード40は取得しない。
            for (let lx = 0; lx < fldctlSelect.length; lx++) {
              if (
                (fldctlSelect[lx].fldctlLvl == 0 &&
                  fldctlSelect[lx].fldctlKnd >= 101) ||
                fldctlSelect[lx].fldctlKnd == 40
              ) {
                continue;
              }
              fldctl.push(fldctlSelect[lx]);
            }
          }
          Logger.debug("[RiverWarn]act - getRiverwarnsListPref");
        }
      }
      //洪水予報と水位周知河川情報のソートの並び替え
      fldfr.sort(function(a, b) {
        if (a.lvl < b.lvl) return 1;
        if (a.lvl > b.lvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      //ダム放流通知のソートの並び替え
      damdsch.sort(function(a, b) {
        if (a.damdschLvl < b.damdschLvl) return 1;
        if (a.damdschLvl > b.damdschLvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      // 水防警報のソートの並び替え
      fldctl.sort(function(a, b) {
        if (a.fldctlLvl < b.fldctlLvl) return 1;
        if (a.fldctlLvl > b.fldctlLvl) return -1;
        if (a.annTime < b.annTime) return 1;
        if (a.annTime > b.annTime) return -1;
        return 0;
      });
      var rw = { fldfr, damdsch, fldctl };
      // パラメータをストアに格納
      commit("setRiverWarnsOvParam", {
        dispTime: appTime,
        townsAcqTime: townsAcqTime,
      });
      // 取得した予警報情報をストアに格納
      commit("setRiverWarnsOvList", rw);
    }),
    /**
     * 高アクセス対応
     * 選択された予警報情報を取得
     * @param {*} param0
     * @param appTime 対象日時
     * @param rwCd 洪水予報区間コード、水位周知河川情報区間コード、水防警報区間コード、ダム放流通知区間コード
     * @param type 予警報種別
     */
    async getSelectedRwDetail({ commit }, { appTime, rwCd, type }) {
      Logger.debug(
        "[RiverWarn]act - getSelectedRwDetail({*},{" +
          appTime +
          "," +
          rwCd +
          "," +
          type +
          "})"
      );
      if (type == 10) {
        const fldfrCd = rwCd;
        // 洪水予報マスタ情報を取得
        const {
          data: mtFldfr,
        } = await RiverWarnJsonRepository.getSelectedMtFldfr(fldfrCd);
        Logger.debug("[RiverWarn]act - getSelectedRwDetail - mtFldfr");
        Logger.dir(mtFldfr);

        // 洪水予報詳細情報を取得
        const { data: fldfr } = await RiverWarnJsonRepository.getSelectedFldfr(
          fldfrCd,
          appTime
        );
        Logger.debug("[RiverWarn]act - getSelectedRwDetail - fldfr");
        Logger.dir(fldfr);

        // 洪水予報詳細情報があるかを判定する。
        if (fldfr) {
          // 取得情報をストアに格納
          commit("setSelectedRwDetail", {
            mt: mtFldfr,
            rw: fldfr.fldfr,
            type,
            rwFlg: true,
          });
        } else {
          // 取得情報をストアに格納
          commit("setSelectedRwDetail", {
            mt: mtFldfr,
            rw: [],
            type,
            rwFlg: false,
          });
        }
      } else if (type == 11) {
        const evstgCd = rwCd;
        // 水位周知河川情報マスタ情報を取得
        const {
          data: mtEvstg,
        } = await RiverWarnJsonRepository.getSelectedMtEvstg(evstgCd);
        Logger.debug("[RiverWarn]act - getSelectedRwDetail - mtEvstg");
        Logger.dir(mtEvstg);

        // 水位周知河川情報詳細情報を取得
        const { data: evstg } = await RiverWarnJsonRepository.getSelectedEvstg(
          evstgCd,
          appTime
        );
        Logger.debug("[RiverWarn]act - getSelectedRwDetail - evstg");
        Logger.dir(evstg);

        // 水位周知河川情報詳細情報があるかを判定する。
        if (evstg) {
          // 取得情報をストアに格納
          commit("setSelectedRwDetail", {
            mt: mtEvstg,
            rw: evstg.evstg,
            type,
            rwFlg: true,
          });
        } else {
          // 取得情報をストアに格納
          commit("setSelectedRwDetail", {
            mt: mtEvstg,
            rw: [],
            type,
            rwFlg: false,
          });
        }
      } else if (type == 20) {
        const fldctlCd = rwCd;
        // 水防警報マスタ情報を取得
        const {
          data: mtFldctl,
        } = await RiverWarnJsonRepository.getSelectedMtFldctl(fldctlCd);
        Logger.debug("[RiverWarn]act - getSelectedRwDetail - mtFldctl");
        Logger.dir(mtFldctl);

        // 水防警報詳細情報を取得
        const {
          data: fldctl,
        } = await RiverWarnJsonRepository.getSelectedFldctl(fldctlCd, appTime);
        Logger.debug("[RiverWarn]act - getSelectedRwDetail - fldctl");
        Logger.dir(fldctl);

        // 水防警報詳細情報があるかを判定する。
        if (fldctl) {
          // 取得情報をストアに格納
          commit("setSelectedRwDetail", {
            mt: mtFldctl,
            rw: fldctl.fldctl,
            type,
            rwFlg: true,
          });
        } else {
          // 取得情報をストアに格納
          commit("setSelectedRwDetail", {
            mt: mtFldctl,
            rw: [],
            type,
            rwFlg: false,
          });
        }
      } else {
        const damdschCd = rwCd;
        // ダム放流通知マスタ情報を取得
        const {
          data: mtDamdsch,
        } = await RiverWarnJsonRepository.getSelectedMtDamdsch(damdschCd);
        Logger.debug("[RiverWarn]act - getSelectedRwDetail - mtDamdsch");
        Logger.dir(mtDamdsch);

        // ダム放流通知詳細情報を取得
        const {
          data: damdsch,
        } = await RiverWarnJsonRepository.getSelectedDamdsch(
          damdschCd,
          appTime
        );
        Logger.debug("[RiverWarn]act - getSelectedRwDetail - damdsch");
        Logger.dir(damdsch);

        // ダム放流通知詳細情報取得があるかを判定する。
        if (damdsch) {
          // 取得情報をストアに格納
          commit("setSelectedRwDetail", {
            mt: mtDamdsch,
            rw: damdsch.damdsch,
            type,
            rwFlg: true,
          });
        } else {
          // 取得情報をストアに格納
          commit("setSelectedRwDetail", {
            mt: mtDamdsch,
            rw: [],
            type,
            rwFlg: false,
          });
        }
      }
      commit("setSelectedWarnType", type);
    },
    /**
     * 河川予警報GeoJson取得
     * @param {*} param0
     * @param towns 市町村リスト
     * @param prefs 都道府県リスト
     * @param prefTownType 都道府県 市町村種別
     * @param getTimeList 取得時間リスト
     * @param fldCtlParty 水防団モード
     * @param nationwide 全国表示
     */
    getRiverWarnGeoJson: takeLatest(async function(
      { commit },
      { towns, prefs, prefTownType, getTimeList, fldCtlParty, nationwide }
    ) {
      Logger.debug(
        "[RiverWarn]act - getRiverWarnGeoJson(towns,prefs,getTimeList," +
          prefTownType +
          "," +
          fldCtlParty +
          "," +
          nationwide +
          ")"
      );
      Logger.dir(towns);
      Logger.dir(prefs);
      Logger.dir(getTimeList);

      // 履歴動画再生状態を「準備状態」に更新
      commit("setHistoryPlayPrepStatus", "ready");

      // 取得した予警報GeoJsonのリスト
      let rwGeoJsonList = [];

      // 地図表示枚数分取得
      for (let numCnt = 0; numCnt < getTimeList.length; numCnt++) {
        // 都道府県/市町村別河川予警報一覧ファイルリスト
        let rwList = [];

        if (nationwide) {
          // 全国表示の場合は全国ファイルのみ取得
          Logger.debug(
            "[RiverWarn]API - getRiverWarnPref(80," + getTimeList[numCnt] + ")"
          );
          const {
            data: rwListPref,
            error: rwListPrefError,
          } = await RiverWarnJsonRepository.getRiverWarnPref(
            80,
            getTimeList[numCnt]
          );
          Logger.debug(
            "[RiverWarn]API - getRiverWarnPref(80," +
              getTimeList[numCnt] +
              ") - return"
          );
          Logger.dir(rwListPref);
          Logger.dir(rwListPrefError);
          // 応答結果が正常な場合
          if (!rwListPrefError) {
            rwList.push(rwListPref);
          }
        } else {
          // 都道府県別河川予警報一覧ファイルを取得
          for (let prefsCnt = 0; prefsCnt < prefs.length; prefsCnt++) {
            // 都道府県別河川予警報一覧ファイルを取得
            Logger.debug(
              "[RiverWarn]API - getRiverWarnPref(" +
                prefs[prefsCnt].id +
                "," +
                getTimeList[numCnt] +
                ")"
            );
            const {
              data: rwListPref,
              error: rwListPrefError,
            } = await RiverWarnJsonRepository.getRiverWarnPref(
              prefs[prefsCnt].id,
              getTimeList[numCnt]
            );
            Logger.debug(
              "[RiverWarn]API - getRiverWarnPref(" +
                prefs[prefsCnt].id +
                "," +
                getTimeList[numCnt] +
                ") - return"
            );
            Logger.dir(rwListPref);
            Logger.dir(rwListPrefError);
            // 応答結果が正常な場合
            if (!rwListPrefError) {
              if (prefTownType == "pref") {
                // 都道府県レベルの場合はそのまま格納
                rwList.push(rwListPref);
              } else {
                // 市町村レベルの場合はtwn配列の中の対象市町村のオブジェクトのみを格納
                const twnList = rwListPref.twn;
                for (let townsCnt = 0; townsCnt < twnList.length; townsCnt++) {
                  if (
                    towns.some((twnObj) => twnObj.id == twnList[townsCnt].twnCd)
                  ) {
                    rwList.push(twnList[townsCnt]);
                  }
                }
              }
            }
          }
        }

        // 予警報GeoJSONを取得するための項目リスト
        let rwItemList = [];

        // 取得した一覧ファイルの数だけ処理を繰り返す
        for (let rwListCnt = 0; rwListCnt < rwList.length; rwListCnt++) {
          // 洪水予報/水位周知情報の数だけ処理を繰り返す
          for (let fCnt = 0; fCnt < rwList[rwListCnt].fldfr.length; fCnt++) {
            const listFldfr = rwList[rwListCnt].fldfr;
            // 洪水予報の場合
            if (listFldfr[fCnt].type == "fldfr") {
              // 洪水予報の危険度判定
              if (listFldfr[fCnt].lvl > 0) {
                rwItemList.push({
                  cd: listFldfr[fCnt].cd,
                  lvl: Number(listFldfr[fCnt].lvl),
                  type: 10,
                  id: listFldfr[fCnt].id,
                });
              }
            }
            // 水位周知情報の場合
            else {
              // 水位周知情報の危険度判定
              if (listFldfr[fCnt].lvl > 0) {
                rwItemList.push({
                  cd: listFldfr[fCnt].cd,
                  lvl: Number(listFldfr[fCnt].lvl),
                  type: 11,
                  id: listFldfr[fCnt].id,
                });
              }
            }
          }

          // 取得した水防警報の数だけ処理を繰り返す
          // 水防団モードの場合のみ取得する
          if (fldCtlParty) {
            for (let cCnt = 0; cCnt < rwList[rwListCnt].fldctl.length; cCnt++) {
              const listfldctl = rwList[rwListCnt].fldctl;
              // 水防警報の危険度判定
              if (listfldctl[cCnt].fldctlLvl > 0) {
                rwItemList.push({
                  cd: listfldctl[cCnt].fldctlCd,
                  lvl: Number(listfldctl[cCnt].fldctlLvl),
                  type: 20,
                  id: listfldctl[cCnt].fldctlId,
                });
              }
            }
          }
        }

        // 時間ごとの予警報GeoJSONリスト
        let rwGeoJsonInfoList = [];

        // GeoJSONファイル取得
        for (let gCnt = 0; gCnt < rwItemList.length; gCnt++) {
          // 予警報区間の重複を省く
          if (
            rwGeoJsonInfoList.some(
              (listObj) =>
                listObj.features[0].properties.type == rwItemList[gCnt].type &&
                listObj.features[0].properties.cd == rwItemList[gCnt].cd
            )
          ) {
            continue;
          }

          let rwGeojson = {};
          let rwGeojsonError = {};
          // 洪水予報
          if (rwItemList[gCnt].type == 10) {
            Logger.debug(
              "[RiverWarn]API - getRwFldfrGeoJson(" + rwItemList[gCnt].cd + ")"
            );
            const {
              data: fldfrData,
              error: fldfrError,
            } = await RiverWarnGeojsonRepository.getRwFldfrGeoJson(
              rwItemList[gCnt].cd
            );
            Logger.debug(
              "[RiverWarn]API - getRwFldfrGeoJson(" +
                rwItemList[gCnt].cd +
                ") - return"
            );
            rwGeojson = fldfrData;
            rwGeojsonError = fldfrError;
          }
          // 水位周知
          if (rwItemList[gCnt].type == 11) {
            Logger.debug(
              "[RiverWarn]API - getRwEvstgGeoJson(" + rwItemList[gCnt].cd + ")"
            );
            const {
              data: evstgData,
              error: evstgError,
            } = await RiverWarnGeojsonRepository.getRwEvstgGeoJson(
              rwItemList[gCnt].cd
            );
            Logger.debug(
              "[RiverWarn]API - getRwEvstgGeoJson(" +
                rwItemList[gCnt].cd +
                ") - return"
            );
            rwGeojson = evstgData;
            rwGeojsonError = evstgError;
          }
          // 水防警報
          if (rwItemList[gCnt].type == 20) {
            Logger.debug(
              "[RiverWarn]API - getRwFldctlGeoJson(" + rwItemList[gCnt].cd + ")"
            );
            const {
              data: fldctlData,
              error: fldctlError,
            } = await RiverWarnGeojsonRepository.getRwFldctlGeoJson(
              rwItemList[gCnt].cd
            );
            Logger.debug(
              "[RiverWarn]API - getRwFldctlGeoJson(" +
                rwItemList[gCnt].cd +
                ") - return"
            );
            rwGeojson = fldctlData;
            rwGeojsonError = fldctlError;
          }
          Logger.dir(rwGeojson);
          Logger.dir(rwGeojsonError);

          // 応答結果が正常な場合
          if (!rwGeojsonError) {
            // 取得したGeoJSONに一覧ファイルの危険度やIDなどを追加
            for (let fCnt = 0; fCnt < rwGeojson.features.length; fCnt++) {
              rwGeojson.features[fCnt].properties.lvl = rwItemList[gCnt].lvl;
              rwGeojson.features[fCnt].properties.type = rwItemList[gCnt].type;
              rwGeojson.features[fCnt].properties.cd = rwItemList[gCnt].cd;
              rwGeojson.features[fCnt].properties.id = rwItemList[gCnt].id;
            }
            rwGeoJsonInfoList.push(rwGeojson);
          }
        }

        // 時間ごとの予警報GeoJSON一覧にGeoJSONデータを格納
        rwGeoJsonList.push({
          date: getTimeList[numCnt],
          rwGeoJsonInfo: rwGeoJsonInfoList,
        });
      }

      // 取得情報をストアに格納
      commit("setRiverWarnLocation", rwGeoJsonList);

      // 履歴動画再生状態を「再生可状態」に更新
      commit("setHistoryPlayPrepStatus", "playable");
    }),
    /**
     * 選択中河川予警報GeoJson取得
     * @param {*} param0
     * @param rwCd 予警報区間コード
     * @param rwType 予警報種別
     */
    getSelectedRwGeoJson: takeLatest(async function(
      { commit },
      { rwCd, rwType }
    ) {
      Logger.debug("[RiverWarn]act - getSelectedRwGeoJson(" + rwCd + ")");
      let returnGeoJson = null;

      // GeoJSONファイル取得
      let rwGeojson = {};
      let rwGeojsonError = {};
      // 洪水予報
      if (rwType == 10) {
        Logger.debug("[RiverWarn]API - getRwFldfrGeoJson(" + rwCd + ")");
        const {
          data: fldfrData,
          error: fldfrError,
        } = await RiverWarnGeojsonRepository.getRwFldfrGeoJson(rwCd);
        Logger.debug(
          "[RiverWarn]API - getRwFldfrGeoJson(" + rwCd + ") - return"
        );
        rwGeojson = fldfrData;
        rwGeojsonError = fldfrError;
      }
      // 水位周知
      if (rwType == 11) {
        Logger.debug("[RiverWarn]API - getRwEvstgGeoJson(" + rwCd + ")");
        const {
          data: evstgData,
          error: evstgError,
        } = await RiverWarnGeojsonRepository.getRwEvstgGeoJson(rwCd);
        Logger.debug(
          "[RiverWarn]API - getRwEvstgGeoJson(" + rwCd + ") - return"
        );
        rwGeojson = evstgData;
        rwGeojsonError = evstgError;
      }
      // 水防警報
      if (rwType == 20) {
        Logger.debug("[RiverWarn]API - getRwFldctlGeoJson(" + rwCd + ")");
        const {
          data: fldctlData,
          error: fldctlError,
        } = await RiverWarnGeojsonRepository.getRwFldctlGeoJson(rwCd);
        Logger.debug(
          "[RiverWarn]API - getRwFldctlGeoJson(" + rwCd + ") - return"
        );
        rwGeojson = fldctlData;
        rwGeojsonError = fldctlError;
      }
      Logger.dir(rwGeojson);
      Logger.dir(rwGeojsonError);

      // 応答結果が正常な場合
      if (!rwGeojsonError) {
        returnGeoJson = rwGeojson;
      }
      // 取得情報をストアに格納
      commit("setSelectedRwGeoJson", returnGeoJson);
    }),
    /**
     * 表示範囲の河川予警報一覧を取得し、河川予警報存在フラグを更新する
     * @param towns 市町村リスト
     * @param prefs 都道府県リスト
     * @param prefTownType 都道府県 市町村種別
     * @param fldCtlParty 水防団モード
     * @param getTime 取得時間
     */
    updateRwExistenceFlg: takeLatest(async function(
      { commit },
      { towns, prefs, prefTownType, fldCtlParty, getTime }
    ) {
      Logger.debug(
        "[RiverWarn]act - updateRwExistenceFlg(towns,prefs," +
          prefTownType +
          "," +
          fldCtlParty +
          "," +
          getTime +
          ")"
      );
      Logger.dir(towns);
      Logger.dir(prefs);

      let flgStatus = false;
      // APIからデータ取得
      for (let prefsCount = 0; prefsCount < prefs.length; prefsCount++) {
        Logger.debug(
          "[RiverWarn]API - getRiverWarnPref(" +
            prefs[prefsCount].id +
            "," +
            getTime +
            ")"
        );
        const { data, error } = await RiverWarnJsonRepository.getRiverWarnPref(
          prefs[prefsCount].id,
          getTime
        );
        Logger.debug(
          "[RiverWarn]API - getRiverWarnPref(" +
            prefs[prefsCount].id +
            "," +
            getTime +
            ") - return"
        );
        Logger.dir(data);
        if (!error) {
          if (prefTownType == "pref") {
            // 都道府県レベルの場合はそのまま判定

            // 危険度レベルが1以上の予警報があれば、以後の処理を実行しない
            // 洪水予報・水位周知河川情報
            if (data.fldfr && data.fldfr.some((fldfr) => fldfr.lvl > 0)) {
              flgStatus = true;
              break;
            }
            // ダム放流通知
            if (
              data.damdsch &&
              data.damdsch.some((damdsch) => damdsch.damdschLvl > 0)
            ) {
              flgStatus = true;
              break;
            }
            if (fldCtlParty === true) {
              // 水防警報
              if (
                data.fldctl &&
                data.fldctl.some((fldctl) => fldctl.fldctlLvl > 0)
              ) {
                flgStatus = true;
                break;
              }
            }
          } else {
            // 市町村レベルの場合はtwn配列の中の対象市町村のオブジェクトのみ判定
            const twnList = data.twn;
            for (let townsCnt = 0; townsCnt < twnList.length; townsCnt++) {
              if (
                towns.some((twnObj) => twnObj.id == twnList[townsCnt].twnCd)
              ) {
                // 洪水予報・水位周知河川情報
                if (
                  twnList[townsCnt].fldfr &&
                  twnList[townsCnt].fldfr.some((fldfr) => fldfr.lvl > 0)
                ) {
                  flgStatus = true;
                  break;
                }
                // ダム放流通知
                if (
                  twnList[townsCnt].damdsch &&
                  twnList[townsCnt].damdsch.some(
                    (damdsch) => damdsch.damdschLvl > 0
                  )
                ) {
                  flgStatus = true;
                  break;
                }
                if (fldCtlParty === true) {
                  // 水防警報
                  if (
                    twnList[townsCnt].fldctl &&
                    twnList[townsCnt].fldctl.some(
                      (fldctl) => fldctl.fldctlLvl > 0
                    )
                  ) {
                    flgStatus = true;
                    break;
                  }
                }
              }
            }
          }
        }
      }
      // 河川予警報存在フラグの状態を更新
      commit("setRwExistenceFlg", flgStatus);
    }),
  }),
};
